var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualFront(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 97,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 28,
    width: 98,
    height: 97
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 29,
    width: 96,
    height: 96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 29,
    width: 96,
    height: 96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 29,
    width: 96,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-514 -28)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.1 102C598.7 100.1 596.9 98.4 595.8 95.6 595.6 95.2 595.5 94.7 595.4 94.3L595.4 94.2C595.2 93.5 594.6 93 593.9 93L532.3 93C531.6 93 531 93.5 530.8 94.2 530.7 94.7 530.6 95.1 530.4 95.6 529.3 98.4 527.4 100.1 525 102.1L525 106.1 601.1 106.1 601.1 102.2C601.1 102.1 601.1 102.1 601.1 102ZM599.1 104 527 104 527 103C529.3 101.3 531.2 98.9 532.3 96.3 532.5 95.9 532.6 95.5 532.7 95L593.5 95C593.6 95.5 593.7 95.9 593.9 96.3 595 98.9 596.8 101.2 599.2 103L599.2 104Z",
    fill: "#464047",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.1 85C593.2 83.2 591.8 80.9 591.1 78.4 588.7 68.6 581.8 62.9 572.1 60.9 571.1 60.7 570.1 60.5 569 60.4 569 59.9 568.8 59.4 568.7 58.9 567.9 57 566.1 55.6 564 55.5L564 51 568 51C568.6 51 569 50.6 569 50 569 49.4 568.6 49 568 49L558 49C557.4 49 557 49.4 557 50 557 50.6 557.4 51 558 51L562 51 562 55.5C560 55.7 558.2 57 557.4 58.9 557.2 59.4 557.1 59.9 557.1 60.4 556.1 60.5 555.1 60.7 554 60.9 544.3 62.9 537.4 68.6 535 78.4 534.3 80.9 532.9 83.2 531 85L531 89 595 89 595.1 85ZM559.3 59.6C559.9 58.3 561.2 57.4 562.7 57.4L563.4 57.4C564.9 57.4 566.2 58.2 566.8 59.6 566.9 59.8 566.9 60.1 567 60.3 566.6 60.3 566.1 60.3 565.7 60.3L560.5 60.3C560.1 60.3 559.6 60.3 559.2 60.3 559.2 60.1 559.2 59.8 559.3 59.6 559.3 59.6 559.3 59.6 559.3 59.6ZM593.1 87 533.1 87 533.1 85.8C535 83.8 536.4 81.4 537 78.8 539.1 70.2 545 64.8 554.5 62.8 556.5 62.4 558.5 62.2 560.5 62.2L565.7 62.2C567.7 62.2 569.7 62.4 571.7 62.8 581.2 64.8 587.1 70.2 589.2 78.9 589.9 81.5 591.2 83.9 593.1 85.8L593.1 87Z",
    fill: "#464047",
    fillRule: "nonzero",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualFront);
export default __webpack_public_path__ + "static/media/virtual_front.a81b6dea1e5abd55af047f99e714e722.svg";
export { ForwardRef as ReactComponent };